import styled from 'styled-components';
import { breakpoint } from '../../theme/breakpoint';
import generateQS from '../../styled/background-image';
import { h3 } from '../../styled/typography';

export const Name = styled.h4`
  margin-top: 0;
  margin-bottom: ${({ theme }) => theme.spacing.tiny};

  ${breakpoint.tablet`
    ${h3};
    margin-top: 0;
  `};
`;

export const Info = styled.div`
  padding: ${({ theme }) => theme.spacing.small};
  font-size: ${({ theme }) => theme.fontsize.small};
  background: ${({ theme }) => theme.palette.white};

  ${breakpoint.mobile`
    font-size: ${({ theme }) => theme.fontsize.base};
    padding: ${({ theme }) => theme.spacing.standard};
    background: ${({ theme }) => theme.palette.white}
  `};

  ${breakpoint.tablet`
    flex-basis: 70%;
    background: ${({ theme }) => theme.palette.white}
  `};
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  cursor: ${({ $hasLink }) => $hasLink && 'pointer'};
  box-shadow: ${({ theme }) => theme.boxshadow.small};

  ${Name} {
    color: ${({ theme, $hasLink }) => $hasLink && theme.palette.link};
    text-decoration: ${({ $hasLink }) => $hasLink && 'underline'};
  }

  &:hover {
    box-shadow: ${({ $hasLink, theme }) =>
      $hasLink && theme.boxshadow.standard};
    ${Name} {
      color: ${({ $hasLink, theme }) => $hasLink && theme.palette.linkHover};
    }
  }

  a:focus ~ ${Info} {
    ${Name} {
      color: ${({ $hasLink, theme }) => $hasLink && theme.palette.linkHover};
    }
  }

  width: ${({ theme }) => `calc(50% - ${theme.spacing.tiny})`};

  ${breakpoint.tablet`
    flex-direction: row;
  `};

  ${breakpoint.desktop`
    width: ${({ theme, $columns }) =>
      $columns && `calc(${100 / $columns}% - ${theme.spacing.standard})`};`};
`;

export const JobTitle = styled.p`
  margin-bottom: ${({ theme }) => theme.spacing.tiny};
`;

const imageSizes = {
  mobile: [200, 200],
};

export const ImageHolder = styled.div`
  ${({ showPhotoOnMobile }) => (showPhotoOnMobile ? '' : 'display: none;')}
  min-height: 160px;
  width: 100%;
  background-size: cover;
  background-position: center;
  background-image: ${({ $image: image }) =>
    image && generateQS({ image, imageSizes, size: 'mobile' })};

  ${breakpoint.tablet`
    flex-basis: 30%;
    min-height: 120px;
    ${({ showPhotoOnMobile }) => (showPhotoOnMobile ? '' : 'display: block;')}
  `}
`;
